import i18n from '@/utils/i18n'

/**
 * Soft-проверка VIN: длина 17 + допустимый алфавит (без I/O/Q).
 *
 * Возвращает `null` если VIN валиден или пустой; иначе — текст подсказки
 * для отображения под полем (НЕ блокирует сохранение).
 *
 * Контрольная сумма по ISO 3779/3780 НЕ проверяется намеренно — для японских,
 * корейских и многих других реальных VIN она часто не сходится. Парная
 * реализация: lib/core/utils/vin_validation.dart в стрижевом моб. приложении.
 */
export function validateVinSoft(raw: string | null | undefined): string | null {
  if (raw == null) return null
  const vin = raw.trim().toUpperCase()
  if (vin.length === 0) return null

  if (vin.length !== 17) return i18n.t('validate.vinLength')
  if (!/^[A-HJ-NPR-Z0-9]+$/.test(vin)) {
    return i18n.t('validate.vinChars')
  }
  return null
}
